import Vue from 'vue';
import Router from 'vue-router';
import store from 'store';
import { Npsmeter } from '@/utils/npsmeter';
import { registerRouter } from './router-operation';
import '@/router/lib/permission'; // 引入路由器拦截器
import { initPermission } from '@/router/lib/permission';
import { createRouter } from './router-dynamic';
import form from './modules/form';

Vue.use(Router);

const router = createRouter();
router.addSelfRoutes = function (params) {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
    router.addRoutes(params);
};

// 注册到操作模块中
registerRouter(router);

// 初始化权限
initPermission(router);

router.afterEach((to,from) => {
	if(from.name){  // 判断是否为初始页面 如果为初始页面不需要发送
	    let toRouter = {  // 记录上一个页面名
	        'routerName': to.meta.title,
	        'routerUrl': to.name
	    }
	    store.dispatch('requestCont/notifyBackend',toRouter)
    }
})

router.beforeEach((to, from, next) => {
    // start 表单新增
    // let staticRoute = router.options.routes.filter(v=>{return v.path == '/static'})
    // staticRoute.map(item => {
    //     item.children.map(v => {
    //         if(v.name == 'form-detail') {
    //             v.meta.parent = from.path
    //         }
    //     })
    // })
    // end
    // store.commit('requestCont/SET_NUM', 1);
    // store.commit('requestCont/SET_TABLEURL', []);

    let toRouter = {  //  记录当前页面路由
	    'routerName':to.meta.title,
	    'routerUrl':to.name
    }
	store.commit('requestCont/updataState',toRouter)

    let thirdCatalog = ['omo', 'design']; // 三方目录

    try {
        if (from.path.indexOf("/np/app/detail/") === 0 && to.path.match(/naaCode(\d+)id(\d+)/is)) {
            Npsmeter.lowCodeContent();
        }
    } catch (e) {}

    try {
        if (from.path.indexOf('/static/product/edit') === 0 && to.path.indexOf('/product/list') === 0) {
            Npsmeter.product();
        }
    } catch (e) { }

    thirdCatalog.map(v => {
        let isThird = window.location.href.indexOf(`/npmanager/${v}`) > -1;
        if (!isThird) {
            next();
        } else {
            if (to.path.indexOf(`/${v}`) > -1) {
                next();
            } else if (to.path.indexOf(`np/app`) !== -1) {
                next();
            } else if (to.path.indexOf(`form/app/detail`) !== -1) {
                next();
            }  else {
                next({
                    path: `/${v}${to.path}`,
                });
            }
        }
    });
});

export default router;
